module.exports = "/_next/static/images/c4c3b7131460c47985f730d05beb1931-rewards-app-xs@3x.png.webp";